// This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0.
// If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.

import i18n from "i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import env from "./env"
i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: false,
        fallbackLng: "en",
        load: "all",
        preload: ["en", "fr"],
        backend: {
            loadPath: `${env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
            // the translation files have no cache headers, so add the build's commit to the URL;
            // otherwise browsers can keep using old translations for days after a release
            queryStringParams: env.REACT_APP_GIT_SHA ? { v: env.REACT_APP_GIT_SHA.substring(0, 7) } : {}
        },
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    })

export default i18n
